/* global axios */
import ApiClient from '../ApiClient';

class CaptainApiTools extends ApiClient {
  constructor() {
    super('captain/api_tools', { accountScoped: true });
  }

  get({ page = 1, assistantId } = {}) {
    return axios.get(this.url, {
      params: {
        page,
        assistant_id: assistantId,
      },
    });
  }

  test(toolData) {
    return axios.post(`${this.url}/test`, toolData);
  }
}

export default new CaptainApiTools();
